export const notesFilterOptions = [
  {
    filterName: 'Uploaded',
    options: [1, 2, 3],
  },
  {
    filterName: 'Branch',
    options: ['CSE', 'ECE', 'DS & AI'],
  },
  {
    filterName: 'Subject',
    options: ['Operating systems', 'DBMS', 'Linear Algebra', 'DSA'],
  },
  {
    filterName: 'Rating',
    options: [4, 3, 2, 1],
  },
];
